import { Star } from "lucide-react";
import { COLLECTION_IMAGES } from "@/constants/categoryImages";
import { COLLECTION_BLURB } from "./constants";
import { CourseGrid } from "./CourseGrid";

export function CollectionLanding({ coll, lessons, countFor, onStartLesson, onOpenCourse }) {
  const firstCat = coll.cats[0];
  const firstLessonId = lessons.find((l) => l.category_id === firstCat?.id)?.id;
  return (
    <div data-testid={`collection-landing-${coll.id}`}>
      <div className="relative overflow-hidden rounded-3xl card-soft mb-6 text-white" style={{ backgroundColor: "#291B2D" }}>
        {COLLECTION_IMAGES[coll.id] && <img src={COLLECTION_IMAGES[coll.id]} alt="" className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: "50% 35%" }} />}
        <div className="absolute inset-0 bg-gradient-to-r from-[#291B2D] via-[#291B2D]/90 to-[#291B2D]/45" />
        <div className="relative z-10 p-8 lg:p-12 max-w-2xl">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C89B55] font-semibold">Collection</p>
          <h2 className="font-heading text-3xl lg:text-5xl mt-1">{coll.title}</h2>
          <p className="text-white/85 mt-3 leading-relaxed">{COLLECTION_BLURB[coll.id] || ""}</p>
          <p className="text-[11px] uppercase tracking-widest text-white/60 mt-4">{coll.cats.length} courses · {coll.cats.reduce((n, c) => n + countFor(c.id), 0)} lessons</p>
          {firstLessonId && (
            <button onClick={() => onStartLesson(firstLessonId)} data-testid={`collection-start-here-btn-${coll.id}`}
              className="mt-6 inline-flex items-center gap-2 bg-[#C89B55] text-[#291B2D] font-semibold rounded-full px-6 py-3 hover:brightness-105 transition-smooth">
              <Star size={16} className="fill-[#291B2D]" /> Start here · {firstCat.title}
            </button>
          )}
        </div>
      </div>
      <CourseGrid cats={coll.cats} countFor={countFor} onOpen={onOpenCourse} testId={`collection-courses-${coll.id}`} />
    </div>
  );
}
